import Scorm from './connector/Scorm';

export var ScormSingleton = Scorm.find();

export interface ISuspendData{
    chapters:{
        [id:string]:boolean,
    },
    attempts:number
}

export var suspendData:{ data:ISuspendData } = { data: { chapters:{}, attempts:0 } };

export function updateSuspendData(){
    ScormSingleton.api.suspendData = JSON.stringify( suspendData.data );
    ScormSingleton.api.commit();
}